import {
	Accordion,
	AccordionItem,
	AccordionButton,
	Flex,
	AccordionPanel,
	Text,
	AccordionIcon,
} from '@chakra-ui/react'
import { format } from 'date-fns'
import { useSharedContext } from './../../context/shared.context'
import { useAuthContext } from './../../context/auth.context'
import { useLanguageContext } from './../../context/locale.context'
import { WhatNextCommonUI } from './whatNextCommonUI'
import PropTypes from 'prop-types'

const WhatNextInitial = ({ roleWiseButtons }) => {
	const {
		state: {
			activity: {
				activity_status_name,
				activity_datetime_end_deferred,
				activity_lead_asset_id,
			},
		},
	} = useSharedContext()

	const {
		state: { locale },
	} = useLanguageContext()

	const {
		state: {
			authData: { operating_asset_first_name, asset_id: auth_asset_id },
		},
	} = useAuthContext()
	const role = activity_lead_asset_id === auth_asset_id ? 'lead' : 'creator'

	const bodyContent = () => {
		return (
			<Accordion
				allowToggle
				defaultIndex={[0]}
				_before={{
					border: 'none',
				}}
			>
				<AccordionItem
					borderTopWidth='0'
					_last={{
						borderBottomWidth: '0',
					}}
				>
					<AccordionButton
						color='gray.300'
						fontWeight='500'
						fontSize='0.75rem'
						pl='0'
					>
						<Text textAlign='left'>
							{`${locale['Dear']} ${operating_asset_first_name}, ${locale['Please take one of the following action to progress further on this']}`}
						</Text>
						<AccordionIcon ml={5} border='1px solid white' borderRadius='5px' />
					</AccordionButton>
					<AccordionPanel pb='0' pl='0'>
						<Flex w={'full'} px={0}>
							<Flex w={'full'} flexDirection='column'>
								<Text fontSize='0.625rem' color='gray.300'>
									{locale['Current Status']}
								</Text>
								<Text textTransform='capitalize' mb='0.625rem'>
									{activity_status_name}
								</Text>
								<Text fontSize='0.625rem' color='gray.300'>
									{locale['Status Due Date']}
								</Text>
								<Text textTransform='capitalize' color='white'>
									{!!activity_datetime_end_deferred
										? activity_datetime_end_deferred.includes('date') ||
										  activity_datetime_end_deferred.includes('0000-00-00')
											? activity_datetime_end_deferred
											: format(
													new Date(
														activity_datetime_end_deferred.split(' ').join('T')
													),
													'do MMM yyyy'
											  )
										: ''}
								</Text>
							</Flex>
						</Flex>
					</AccordionPanel>
				</AccordionItem>
			</Accordion>
		)
	}

	const buttonsList =
		role === 'lead' ? roleWiseButtons['lead'] : roleWiseButtons['creator']

	return (
		<>
			<WhatNextCommonUI
				headerText={locale["What's next action"]}
				bodyContent={bodyContent()}
				buttonsList={buttonsList}
			/>
		</>
	)
}

WhatNextInitial.propTypes = {
	roleWiseButtons: PropTypes.shape({
		lead: PropTypes.array.isRequired,
		creator: PropTypes.array.isRequired,
	}),
}

export { WhatNextInitial }
